module.exports = __webpack_public_path__ + "static/media/warehouse.7a8f7c3f.svg";